import styles from "../../styles/common/ModalForm.module.scss";
import creditLineStyles from "../../styles/views/CreditLineDetail.module.scss";

import React, {useCallback, useState} from "react";
import clsx from "clsx";
import { ArrowUpRight } from 'lucide-react';

import {HomeRepayCreditModalViewList} from "../../utils";
import {AvailableBalance} from "../../utils/creditService";

import Modal from "../common/Modal";

interface HomeRepayCreditModalProps {
  creditLine: AvailableBalance
}

function HomeRepayCreditModal({creditLine}: HomeRepayCreditModalProps) {
  const [currentView, setCurrentView] = useState(0)

  const [homeRepayCreditModalIsOpen, setHomeRepayCreditModalIsOpen] = useState(false)

  const handleToggleModal = useCallback(() => {
    setHomeRepayCreditModalIsOpen(homeRepayCreditModalIsOpen => !homeRepayCreditModalIsOpen)
  }, [setHomeRepayCreditModalIsOpen])

  const handleCloseModal = useCallback(() => {
    setHomeRepayCreditModalIsOpen(false)
    setCurrentView(0)
  }, [setHomeRepayCreditModalIsOpen])

  const handleBack = () => {
    setCurrentView(0)
  }

  const views = HomeRepayCreditModalViewList({ onCloseModal: handleCloseModal, setCurrentView, handleBack, creditLine })

  return (
    <>
      <button 
        className={clsx(creditLineStyles.actionButton, creditLineStyles.secondary)}
        onClick={handleToggleModal}
        disabled={creditLine.used <= 0}
      >
        <ArrowUpRight className={creditLineStyles.buttonIcon} />
        <span>Repay Credit</span>
      </button>

      <Modal
        extraClassName={clsx(styles.cModalForm, "c-modal-form", "c-home-repay-credit-modal", `view-${views[currentView].id}`)}
        isModalOpen={homeRepayCreditModalIsOpen}
        onCloseModal={handleCloseModal}
        hideModalHeader
        modalSize={currentView === 0? "md" : "sm"}
      >

      {views[currentView].component}

      </Modal>
    </>
  );
}

export default HomeRepayCreditModal;